var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.waterfall = function (widget, chart, data, metadata) {
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }

    setTimeout(function () {
        MDB.Charts.emptyChartAndMakeVisible(widget, chart);

        var useLegacyKeyTransform = metadata && metadata.KendoConfig && metadata.KendoConfig._UseLegacyKeyTransformation;

        var keyMappings = MDB.Charts.transformKeysToKendoFields(data, useLegacyKeyTransform);
        var keys = MDB.Charts.getDataKeys(data[0]);
        
        var name = keyMappings.findByKey(keys[1]).originalKey
            , categoryField = keys[0]
            , field = keys[1];
        
        if (!metadata.KendoConfig) {
            metadata.KendoConfig = {};
        }
        if (!metadata.KendoConfig.kendoType) {
            metadata.KendoConfig.kendoType = 'waterfall';
        }

        var container = $('<div class="waterfall">').css({ width: '90%', height: '90%', top: '5%', left: '5%' });
        var values = data || 0;
        
        var kendoConfig = {
            legend: {
                position: "bottom"
            },
            series: [
                {
                    type: metadata.KendoConfig.kendoType,
                    name: name,
                    categoryField: categoryField,
                    field: field,
                    data: values
                }
            ]
        };

        kendoConfig = $.extend(true, kendoConfig, metadata.KendoConfig);


        var formatableValues = MDB.Charts.getAggregatedFormatableValues(values, keys);

        var singleSeries = kendoConfig.series[0];

        if (singleSeries.labels){
            MDB.Charts.setLabelFormat(singleSeries, kendoConfig.seriesDefaults, formatableValues, field, undefined);
            MDB.Charts.setLabelFormat(singleSeries, kendoConfig.seriesDefaults, formatableValues, field, 'tooltip');
        }
        
        MDB.Charts.initializeLegendClickHandler(kendoConfig);

        chart.height(MDB.Charts.calculateKendoChartMaxHeight(widget)).append(container);
        container.kendoChart(kendoConfig);
    }, 0);
};